module.exports = __webpack_public_path__ + "static/media/sndvol32_300.0e80b298.ico";